export default __webpack_public_path__ + "static/media/keerthi.259e570e.jpg";